import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./usergroup.css";
import { faAngleRight, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Avatar, Box, Typography } from '@mui/material';
const profileImage = require('../../assets/defaultprofile.svg').default;
function UserRoleDetail() {
    const [showData, setShowData] = useState([]);
    const [groupData, setGroupData] = useState([]);
    const [paginatedata2, setPaginateData2] = useState({});
    const [currentPage2, setCurrentPage2] = useState(1);
    const [searchQuery2, setSearchQuery2] = useState("");
    const [memberData, setMemberData] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("group");

    const fetchGroupData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {
                page: 1,
                type: "groups",
            };
            const finalParams = { ...defaultParams, ...params };

            const response = await apiService.postRequest(`permission/${id}`, finalParams);
            setShowData(response.data);
            setGroupData(response.data?.roles?.data);
            setPaginateData2(response.data?.roles);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setLoading(false);
        }
    }, [id]);

    // Handle page change
    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
        fetchGroupData({ page: newPage });
    };

    const handleSearch2 = () => {
        setCurrentPage2(1);
        fetchGroupData({ search: searchQuery2 });
    };

    useEffect(() => {
        fetchGroupData();
    }, [fetchGroupData]);

    const fetchMemberData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = {
                page: 1,
                type: "members",
            };
            const finalParams = { ...defaultParams, ...params };

            const response = await apiService.postRequest(`permission/${id}`, finalParams);
            
            setMemberData(response.data?.members?.data);
            setPaginateData(response.data?.members);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setLoading(false);
        }
    }, [id]);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchMemberData({ page: newPage });
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchMemberData({ search: searchQuery });
    };
    useEffect(() => {
        fetchMemberData();
    }, [fetchMemberData]);

    const rows2 = groupData && groupData.map((datas, index) => ({
        id: datas.id,
        index: index + 1,
        groupType: datas.group_type || "N/A",
        groupName: datas.display_name || "N/A",
    }));
    const columns2 = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 300,
            flex: 1,
            filterable: false,
        },
        {
            field: 'groupName',
            headerName: 'Group Name',
            minWidth: 300,
            flex: 1,
            filterable: true
        },
        {
            field: 'groupType',
            headerName: 'Group Type',
            minWidth: 300,
            flex: 1,
            filterable: true
        },
    ];
    const rows = memberData && memberData.map((datas) => ({
        id: datas.id,
        formatId: datas.format_id,
        user_type: datas.user_type,
        userName: datas.name,
        userImage: datas.profile || profileImage,
        contactEmail: datas.email,
    }));
    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            minWidth: 300,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.user_type === "sub_admin" ? 
                        <Link to={`/user/member-edit/${params.row.id}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatId}</Link>
                    :
                        <Link to={`/user/jobseeker-details/${params.row.id}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatId}</Link>
                    }
                </div>
            ),
            filterable: false,
        },
        {
            field: 'userName',
            headerName: 'User',
            minWidth: 300,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <Avatar src={params.row.userImage} alt={params.row.userName} />
                    <span className='ms-3'>{params.row.userName}</span>
                </div>
            ),
            filterable: false
        },
        {
            field: 'contactEmail',
            headerName: 'Email',
            minWidth: 300,
            flex: 1,
            filterable: false,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a></span></Typography>
                </Box>
            )
        },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/permissions")}>User</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/permissions")}>Permission</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Permission Details</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Permission Details</h2>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center">
                    {loading === true ?
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> : <>
                        <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="group_rolesdetailsshow">
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="mb-3">
                                <span>Name</span>
                                <p>{showData.display_name || "No Name"}</p>
                            </Grid>
                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="mb-3">
                                <span>Description</span>
                                <p>{showData.description || "No Description"}</p>
                            </Grid>
                        </Grid>
                        <Grid size={{sm:11,xs:12}} container justifyContent="flex-start" className="statusselectbtn">
                            <div className='admintab_btnredirect'>
                                <button className={activeTab === "group" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("group")}}>Groups</button>
                                <button className={activeTab === "members" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("members")}} >Members</button>
                            </div>
                        </Grid>  
                        {activeTab === "group" ?
                        <Grid size={{sm:11,xs:12}} container className="mt-4 pb-3" style={{height:"fit-content"}}>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                                <h4 className='my-3'>Groups</h4>
                                <Grid size={{ xl:4, md:5 , sm:6 ,xs: 12 }} container flexDirection="column">
                                    <div className='d-flex jobseekersearch my-3'>
                                        <div className='col-md-9 input_jobssearch'>
                                            <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                            <input type='text' placeholder='search'
                                                value={searchQuery2}
                                                onChange={(e) => setSearchQuery2(e.target.value)}
                                                onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch2(); // Trigger search on Enter key press
                                                }
                                            }}/>
                                        </div>
                                        <div className='col-md-3 col-4'>
                                            <button onClick={handleSearch2}>Search</button>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid size={{xs:12}} className="datatable_jobpagi">
                                <DataGrid
                                    style={{minHeight:"200px"}}
                                    rows={rows2}
                                    columns={columns2}
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                />
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange2(currentPage2 - 1)} 
                                    disabled={currentPage2 === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata2 && paginatedata2.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata2.last_page);
                                        const pages = [];
            
                                        const start = Math.max(2, currentPage2 - 2);
                                        const end = Math.min(totalPages - 1, currentPage2 + 2);
            
                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange2(1)}
                                            className={currentPage2 === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );
            
                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }
            
                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange2(i)}
                                                className={currentPage2 === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }
            
                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }
            
                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange2(totalPages)}
                                                className={currentPage2 === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }
            
                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange2(currentPage2 + 1)} 
                                    disabled={currentPage2 === paginatedata2.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                        </Grid> :
                        <Grid size={{sm:11,xs:12}} container className="mt-4 pb-3" style={{height:"fit-content"}}>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                                <h4 className='my-3'>Members</h4>
                                <Grid size={{ xl:4, md:5, sm:6 ,xs: 12 }} container flexDirection="column">
                                    <div className='d-flex jobseekersearch my-3'>
                                        <div className='col-md-9 input_jobssearch'>
                                            <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                            <input type='text' placeholder='search'
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch(); // Trigger search on Enter key press
                                                }
                                            }}/>
                                        </div>
                                        <div className='col-md-3 col-4'>
                                            <button onClick={handleSearch}>Search</button>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid size={{xs:12}} className="datatable_jobpagi">
                                <DataGrid
                                    style={{minHeight:"200px"}}
                                    rows={rows}
                                    columns={columns}
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                />
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];
            
                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);
            
                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );
            
                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }
            
                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }
            
                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }
            
                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }
            
                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                        </Grid>}
                    </>}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default UserRoleDetail
